import { useState, useEffect, useRef, memo, useContext, cloneElement, Children } from 'react'

import { availableOn, formattedVariableValue, isValidationCommentEnabled, isValidationSuggestionEnabled, NUMBER_FORMATTERS } from '../../utils'
import { EMPTY_LINES } from '../../constants'
import { User, AddressCard, Pen } from '../../assets/icons'
import { CustomTooltip, Input } from '../ui_new'
import { NotificationContext, SingleDocumentContext, UserContext, ValidationContext } from '../../context'
import { AddComment, Cancel, Create } from '@mui/icons-material'
import { ClickAwayListener } from '@mui/material'
import SingleDocumentSuggestionModal from './SingleDocumentSuggestionModal'
import { TextInput } from './VariableTextInput'

const ValidationModeInputWrapper = ({ children, sectionIndex, variable, value, repeatableIds, repetitionIndices, handle }) => {
  // const { variable, tooltip, type, idx} = fieldVariable
  let classes = "tooltip-wrapper doc-variable-el"

  const { document, revisionModeEnabled, promptAddComment, promptAddSuggestion } = useContext(SingleDocumentContext)
  const { user, userClaims } = useContext(UserContext)
  const { setNotification } = useContext(NotificationContext)

  // const [validationModeEditEnabled, setValidationModeEditEnabled] = useState(false)
  const [showSuggestionModal, setShowSuggestionModal] = useState(false)
  const [suggestionValue, setSuggestionValue] = useState(null)
  const [existingSuggestion, setExistingSuggestion] = useState(null)

  useEffect(() => {
    setSuggestionValue(value)
  }, [value])

  useEffect(() => {
    const variableSuggestion = (document?.suggestions || []).find((s) => {
      if(variable.variable === s.variable.variable) {
        // if(!repeatableIds && !repetitionIndices) {
        //   return s.repeatableIds?.length === 0 && s.repetitionIndices?.length === 0
        // }
        // return s.repeatableIds?.length > 0 && repeatableIds?.every((id, index) => id === s.repeatableIds[index]) &&  s.repetitionIndices?.length > 0 && repetitionIndices?.every((id, index) => id === s.repetitionIndices[index])
        return true
      }
      return false
    })
    if(variableSuggestion) {
      setExistingSuggestion(variableSuggestion)
    } else {
      setExistingSuggestion(null)
    }
  }, [document, variable, repeatableIds, repetitionIndices])

  const onSuggestionSubmit = () => {
    //   // create a suggestion and return value to original
      if(suggestionValue === value) {
        // setValidationModeEditEnabled(false)
        // setShowSuggestionModal(false)
        // setSuggestionValue(value)
        setNotification({ msg: "La valeur proposée est identique à la valeur actuelle.", type: "info" })
        return
      }
      const suggestion = {
        variable,
        value: suggestionValue,
        repeatableIds: repeatableIds,
        repetitionIndices: repetitionIndices,
        sectionIndex: sectionIndex,
      }
      console.log("promptAddSuggestion", suggestion)
      promptAddSuggestion(suggestion)
      setShowSuggestionModal(false)
  }

  const renderChildren = (editable) =>
    Children.map(children, (child) =>
      cloneElement(child, {
        locked: !editable,
        disabled: !editable,
        onValueChange: (value) => {
          setSuggestionValue(value)
        },
        label: editable ? "Votre proposition de modification" : '',
        style: `${child.props.style || ''} ${editable ? 'w-full' : ''}`,
        val: editable ? suggestionValue : child.props.val,
      })
  )

  const [showBottomBar, setShowBottomBar] = useState(false)

  const toggleBottomBar = () => {
    setShowBottomBar(showBottomBar => !showBottomBar)
  }

  if(revisionModeEnabled) {
    return (
      <div className='inline-flex flex-row flex-wrap !max-w-100'>
        <div className={`revision-mode revision-mode__input !max-w-100 revision-mode__input--edit ${existingSuggestion ? 'revision-mode__input--with-suggestion' : ''}`} onClick={toggleBottomBar}>
          {/* {children} */}
          {renderChildren()}
          {(isValidationCommentEnabled(user, document, userClaims) || isValidationCommentEnabled(user, document, userClaims)) &&
            <>
              <div className="revision-mode__input-actions desktop">
                {isValidationSuggestionEnabled(user, document, userClaims) && 
                  <button className='icon-btn icon-btn--border-light icon-btn--md !rounded' type="button" onClick={() => {
                    // setValidationModeEditEnabled(true)
                    setShowSuggestionModal(true)
                  }}>
                    <Create />
                  </button>
                }
                {isValidationCommentEnabled(user, document, userClaims) &&
                  <button className='icon-btn icon-btn--border-light icon-btn--md !rounded' type="button" onClick={() => promptAddComment({ section: { index: sectionIndex, content: '' }, variable: { ...variable, value: value } })}>
                    <AddComment />
                  </button>
                }
              </div>
            </>
         }
        </div>
        {showBottomBar && <ClickAwayListener onClickAway={() => setShowBottomBar(false)}>
          <div className="bottom-bar bottom-bar__mobile flex-column">   
            <div className='w-full mb-4 flex flex-row justify-end'>
              <button className='btn btn--transparent btn--with-icon btn--large' type="button" onClick={() => {
                toggleBottomBar()
              }}>
                <Cancel />
                Fermer
              </button>
            </div>
            <div className='w-full btn__group btn__group--primary-light'>           
              {isValidationSuggestionEnabled(user, document, userClaims) && 
                <button className='btn btn--white btn--with-icon btn--border-radius-sm w-full btn--large !justify-start' type="button" onClick={() => {
                  // setValidationModeEditEnabled(true)
                  setShowSuggestionModal(true)
                }}>
                  <Create />
                  Proposition de modification
                </button>
              }
              {isValidationCommentEnabled(user, document, userClaims) &&
                <button className='btn btn--white btn--with-icon btn--border-radius-sm w-full btn--large !justify-start' type="button" onClick={() => promptAddComment({ section: { index: sectionIndex, content: '' }, variable: { ...variable, value: value } })}>
                  <AddComment />
                  Commenter
                </button>
              }
            </div>
          </div>
        </ClickAwayListener>}
        {showSuggestionModal && (
          <SingleDocumentSuggestionModal
            variable={variable}
            onSubmit={onSuggestionSubmit}
            onClose={() => {
              setShowSuggestionModal(false)
            }}>
            {renderChildren(true)}
          </SingleDocumentSuggestionModal>
        )}
        {existingSuggestion && (
          <div className={`revision-mode revision-mode__input revision-mode__input--suggestion`}>
            <div className={classes}>
              <div style={{padding: '5px 0'}}>
                <TextInput
                  value={formattedVariableValue(variable, existingSuggestion.value, handle)}
                  variable={variable}
                  locked={true}
                  type="text"
                  tooltip={''} />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    children
  )
}

export default memo(ValidationModeInputWrapper)